<script lang="ts">
  import moment from "moment";
  import { appManager } from "../AppManagerStore";
  import type { Author } from "./Author";
  import type { Post } from "./Post";
  import { _, locale } from "svelte-i18n";

  export let post: Post;
  export let author: Author;

  let url: string = "";
  let formattedDate: string = "";
  let title = "";
  let tagline = "";
  let tags: string[] = [];
  let localeNotAvailable = false;

  $: if (typeof post !== "undefined") {
    url = `${$appManager.PublicUrl}blog/${post.id}`;

    formattedDate = moment(post.date).format("MMMM YYYY");
  }

  //locale.subscribe((ln) => {
  $: if (typeof post !== "undefined") {
    let translation = post.translations[post.lang];
    if (typeof post.translations[$locale] !== "undefined") {
      translation = post.translations[$locale];
      localeNotAvailable = false;
    } else {
      localeNotAvailable = true;
    }
    title = translation.title;
    tagline = translation.tagline;
    tags = translation.tags;
  }
  // });
</script>

<div class="col-xl-6 col-md-12 col-12 d-flex mb-4 mt-4">
  <!-- Card -->
  <div
    class="card text-reset text-decoration-none shadow-extra-dark-lg mb-6 mb-xl-0 overlay overlay-30 bg-cover promoted-post"
    style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0),rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url({$appManager.PublicUrl}{post.image});">
    <div class="position-relative card-body d-flex flex-column">
      <p>
        {#each tags as tag}
          <span class="badge bg-light me-1">{tag}</span>
        {/each}
      </p>

      <!-- Heading -->
      <h1 class="text-white mt-auto">
        <a class="text-white no-underline" href={url}>{title}</a>
      </h1>

      <!-- Text -->
      <p class="text-white mb-5">
        <a class="text-white no-underline" href={url}>{tagline}</a>
      </p>

      <!-- Meta -->
      <div class="row pt-5 border-top border-white-20">
        <div class="col">
          <h6 class="text-uppercase text-white mb-0">
            {author.name}
          </h6>
        </div>
        <div class="col-auto">
          <!-- Date -->
          <p class="h6 text-uppercase text-white mb-0">
            <time>{formattedDate}</time>
          </p>
        </div>
      </div>
      <!-- / .row -->
    </div>
  </div>
</div>

<style>
  .promoted-post {
    height: 600px;
  }

  .position-relative {
    position: relative !important;
    height: 100%;
  }

  .shadow-extra-dark-lg {
    box-shadow: 0 1.5rem 4rem rgba(22, 28, 45, 0.5) !important;
  }
</style>
